import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#7df3e1',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg} viewBox="0 0 765.35496 765.35498" xmlns="http://www.w3.org/2000/svg">
      <circle fill="#fff" cx="194.882" cy="155.90601" r="153.071" transform="matrix(2.5 0 0 2.5 -104.52751 -7.087517)"/>
      <path fill="#fc0" d="m618.77499 600.717483 24.1975 22.3675c-37.5725 40.6625-84.5525 72.5025-137.4875 92.06l-11.4075-30.9225c48.01-17.7425 90.6225-46.6225 124.6975-83.505z"/>
      <path fill="#e60000" d="m470.06999 692.027483 8.9475 31.725c-30.6325 8.635-62.9475 13.255-96.34 13.255-33.3075 0-65.5425-4.595-96.1025-13.19l8.9475-31.7225c27.715 7.7925 56.95 11.96 87.155 11.96 30.2925 0 59.6075-4.19 87.3925-12.0275z"/>
      <path d="m271.50749 684.307483-11.41 30.9225c-52.96-19.525-99.97-51.3425-137.5725-91.99l24.1975-22.3675c34.1075 36.8675 76.7475 65.725 124.785 83.435z"/>
      <path fill="#878787" d="M635.16499 581.529983c43.145-54.7075 68.89-123.7725 68.89-198.8525 0-177.4925-143.885-321.3775-321.3775-321.3775s-321.3775 143.885-321.3775 321.3775c0 75.15 25.795 144.275 69.0125 199.0075l-25.8775 20.405c-47.65-60.3425-76.0875-136.5575-76.0875-219.4125 0-195.6925 158.64-354.33 354.33-354.33s354.33 158.64 354.33 354.33c0 82.785-28.39 158.9375-75.965 219.255z"/>
      <g transform="matrix(2.5 0 0 2.5 -104.52751 -7.087517)">
        <circle fill="#00965a" cx="194.882" cy="155.905" r="115.228"/>
        <path fill="#fff" d="m297.874 132.372-65.917-38.2v19.245l33.298 18.955-81.838 46.539V133.13l34.586 20.065v-18.422l-34.586-19.941V85.406l34.586 19.95V86.049l-51.239-29.535v48.723l-42.156-24.355-.088 151.28 42.244-24.364v48.847l16.653-9.655v-48.838l56.32-32.478 25.518 15.237-67.661 38.653v19.25l100.28-57.903-41.909-24.483zm-131.11 56.133-25.481 14.827-.066-94.452 25.547 14.77z"/>
      </g>
    </svg>

  );
};

export default LogoIcon;
